import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import useTimeStandardData from '../../../state/timeStandard/UseTimeStandardData';

import useSecurityData from '@usas/ui-web/state/security/UseSecurityData';

import Constants from '@usas/ui-web/utils/Constants';

const ERROR = 'At least one age group is required';

const useTimeStandardAgeGroup = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({ tryRedirect: false, error: '', timeStandardId: '', redoGet: false });
  const { getContextSecurity } = useSecurityData();
  const { timeStandardState, clearObjData, getTimeStandard, deleteTimeStandardAgeGroup } = useTimeStandardData();

  const onAddAgeGroup = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    navigate(NavLinks.TIME_STANDARDS_AGE_GROUP_ADD);
  }

  const onDeleteAgeGroup = (e, timeStandardAgeGroupId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (timeStandardState.objData?.timeStandardAgeGroup?.length === 1) {
      setState({ ...state, error: ERROR });
    }
    const timeStandardId = timeStandardState.objData.timeStandardId;
    deleteTimeStandardAgeGroup(timeStandardAgeGroupId);
    setState({ ...state, timeStandardId: timeStandardId, redoGet: true });
  }

  const onCreateClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (timeStandardState.objData?.timeStandardAgeGroup?.length === 0) {
      setState({ ...state, error: ERROR });
    }
    else {
      setState({ ...state, tryRedirect: true });
    }
  }

  const onCancelClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (timeStandardState.objData?.timeStandardAgeGroup?.length === 0) {
      setState({ ...state, error: ERROR });
    }
    else {
      setState({ ...state, tryRedirect: true });
    }
  }

  useEffect(() => {
    getContextSecurity(timeStandardState.objData.timeStandardId, 'Times');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (timeStandardState.isObjLoaded === true && timeStandardState.isSaved === true &&
      state.timeStandardId !== '' && state.redoGet === true) {
      getTimeStandard(state.timeStandardId);
      setState({ ...state, timeStandardId: '', redoGet: false });
    }
  }, [timeStandardState, state.timeStandardId, state.redoGet])

  useEffect(() => {
    if (Object.keys(timeStandardState.objData).length > 0 && timeStandardState.isObjLoaded === true
      && state.tryRedirect === true && state.error === '') {
      clearObjData();
      navigate(NavLinks.TIME_STANDARDS_SEARCH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeStandardState.objData, timeStandardState.isObjLoaded, state])

  return {
    timeStandardState,
    state,
    onAddAgeGroup,
    onDeleteAgeGroup,
    onCreateClicked,
    onCancelClicked,
    Constants
  }
};

export default useTimeStandardAgeGroup;
